import '.c0{position:relative;}.ssr-plugin'
import '.is{width:64px;}.ssr-plugin'
import '.it{height:64px;}.ssr-plugin'
import '.b8{flex-shrink:0;}.ssr-plugin'
import '.l{position:absolute;}.ssr-plugin'
import '.iu{bottom:-4px;}.ssr-plugin'
import '.ds{right:-4px;}.ssr-plugin'
import '.ej{border-radius:50%;}.ssr-plugin'
import '.iv{border:2px solid var(--shades-white);}.ssr-plugin'
import '.p{overflow:hidden;}.ssr-plugin'
import '.iw{width:32px;}.ssr-plugin'
import '.ix{height:32px;}.ssr-plugin'
import { styled } from 'inlines'
import { Avatar } from '@app/components/core/avatar/Avatar'
import { Image } from '@app/components/core/image/Image'
import { resizeImage } from '@app/util/helpers'

type ConversationAvatarProps = {
  initiativeImage?: string
  userAvatar?: string
  userName: string
}

export const ConversationAvatar = ({
  initiativeImage,
  userAvatar,
  userName,
}: ConversationAvatarProps) => {
  return (
    <div className="c0 is it b8"
    >
      {initiativeImage ? (
        <Image
          src={resizeImage(initiativeImage, 128)}
          alt="initiative"
          style={{
            width: '100%',
            height: '100%',
            objectFit: 'cover',
            borderRadius: '12px',
          }}
        />
      ) : (
        <Avatar
          size="medium"
          shape="square"
          labelSource={userName}
          variant="yellow"
        />
      )}
      <div className="l iu ds ej iv p iw ix"
      >
        <Avatar
          size="extra-small"
          shape="circle"
          image={userAvatar}
          labelSource={userName}
        />
      </div>
    </div>
  )
}
